import { createSelector } from '@ngrx/store';

import { getBackState, IBackState } from '../back.state';
import * as fromMiscReducer from '@apps/back/store/misc/misc.reducer';
import { PartialEntity } from '@apps/back/models';

const getBackMiscState = createSelector(
    getBackState,
    (state: IBackState) =>
        state[fromMiscReducer.BackMiscFeatureKey]
);

export const getEntityDetails = createSelector(
    getBackMiscState,
    (state: fromMiscReducer.IBackMiscState): PartialEntity =>
        state.entity
);

export const getUserDetails = createSelector(
    getBackMiscState,
    (state: fromMiscReducer.IBackMiscState) =>
        state.user
);